import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtopandharpurcab() {



    const cardData = {




keyword: "Belgaum to Pandharpur Cab",

headingDescription: "Belgaum Taxi Service provides safe, comfortable, and reliable Belgaum to Pandharpur cab services for pilgrimage trips, family travel, religious tours, senior citizen journeys, and outstation transportation. Whether you need a one-way taxi or a round-trip cab from Belgaum to Pandharpur, we offer convenient travel solutions with experienced drivers and well-maintained vehicles. Our fleet includes Swift Dzire, Sedan, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, and premium cars suitable for individuals, families, and large groups. We provide doorstep pickup from your preferred location in Belgaum, flexible travel timings, comfortable highway journeys, transparent pricing, easy booking options, and 24/7 customer support for a hassle-free travel experience. Belgaum Taxi Service helps devotees and travelers reach Pandharpur, one of Maharashtra's most important pilgrimage destinations, known for the famous Vitthal Rukmini Temple and spiritual significance. Our Belgaum to Pandharpur taxi service is ideal for temple visits, family pilgrimages, group tours, and religious journeys with complete comfort and safety.",

topPlaces: [
  {
    title: "Pandharpur Vitthal Rukmini Temple",
    description: "Pandharpur Vitthal Rukmini Temple is one of Maharashtra's most famous pilgrimage sites dedicated to Lord Vitthal and Goddess Rukmini. Thousands of devotees visit this sacred temple throughout the year."
  },
  {
    title: "Chandrabhaga River",
    description: "Chandrabhaga River is a holy river near Pandharpur where devotees take a spiritual bath before visiting the Vitthal Temple. It is an important part of the pilgrimage experience."
  },
  {
    title: "Akkalkot",
    description: "Akkalkot is a famous spiritual destination in Maharashtra known for Swami Samarth Maharaj Temple and attracts devotees from different parts of India."
  },
  {
    title: "Solapur",
    description: "Solapur is a major city near Pandharpur known for industries, textile businesses, religious attractions, and commercial activities. It is an important travel destination in Maharashtra."
  },
  {
    title: "Tuljapur",
    description: "Tuljapur is a popular pilgrimage destination famous for Tulja Bhavani Temple, attracting devotees and tourists throughout the year."
  },
  {
    title: "Bijapur",
    description: "Bijapur is a historic city in Karnataka known for Gol Gumbaz, ancient monuments, and architectural heritage, making it a popular sightseeing destination."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is a famous Maharashtra city known for Mahalaxmi Temple, historical attractions, traditional markets, and cultural heritage."
  },
  {
    title: "Pune",
    description: "Pune is a major IT, education, and industrial hub in Maharashtra with corporate offices, technology parks, universities, and business centers."
  },
  {
    title: "Mumbai",
    description: "Mumbai is India's financial capital known for business districts, airports, entertainment areas, and tourist attractions. Private cabs provide comfortable connectivity for long-distance travel."
  },
  {
    title: "Goa",
    description: "Goa is a popular holiday destination famous for beaches, resorts, churches, and sightseeing attractions. Travelers often combine pilgrimage and leisure trips with private cab services."
  }
],




"services": [
  {
    "name": "Belgaum to Pandharpur Cab",
    "description": "Book Belgaum to Pandharpur Cab for safe, comfortable, and reliable outstation travel with professional chauffeurs and well-maintained AC vehicles. Enjoy a smooth journey from Belgaum to Pandharpur with multiple cab options including Sedan, Ertiga, Innova Crysta, and SUV. Our cab services are ideal for Pandharpur temple visits, family trips, pilgrimage tours, business travel, and personal journeys with flexible one way and round trip booking options."
  },
  {
    "name": "Belgaum to Pandharpur Taxi",
    "description": "Choose Belgaum to Pandharpur Taxi for convenient and affordable transportation with experienced drivers and comfortable vehicles. Travel hassle-free with doorstep pickup, clean AC cars, transparent pricing, and reliable taxi services. Our taxis are suitable for devotees visiting Pandharpur, families, corporate travelers, and passengers looking for safe long-distance travel."
  },
  {
    "name": "Belgaum to Pandharpur Cab Service",
    "description": "Hire Belgaum to Pandharpur Cab Service for dependable intercity transportation with professional chauffeurs and premium vehicles. Get comfortable seating, timely pickup, affordable fares, and flexible travel plans. We provide reliable cab solutions for pilgrimage trips, family vacations, sightseeing tours, corporate travel, and outstation journeys between Belgaum and Pandharpur."
  },
  {
    "name": "Belgaum to Pandharpur Taxi Service",
    "description": "Book Belgaum to Pandharpur Taxi Service for safe and comfortable travel with experienced drivers and well-maintained vehicles. Enjoy smooth rides with Sedan, Ertiga, Innova Crysta, and SUV options. Our taxi services provide convenient transportation for temple visits, family tours, business requirements, and personal travel needs."
  },
  {
    "name": "Belgaum to Pandharpur One Way Cab",
    "description": "Reserve Belgaum to Pandharpur One Way Cab for economical single-direction travel without return charges. Get private cab service with professional drivers, comfortable AC vehicles, and timely pickup facilities. One way cabs are perfect for passengers travelling to Pandharpur for pilgrimage, work, family visits, and personal requirements."
  },
  {
    "name": "Belgaum to Pandharpur One Way Taxi",
    "description": "Choose Belgaum to Pandharpur One Way Taxi for direct and convenient transportation. Enjoy affordable pricing, clean vehicles, experienced chauffeurs, and flexible departure schedules. Our one way taxi service offers a comfortable travel experience for individuals, families, and groups."
  },
  {
    "name": "Belgaum to Pandharpur Cab Booking",
    "description": "Complete Belgaum to Pandharpur Cab Booking with easy reservation facilities and multiple vehicle choices. Select from Sedan, Ertiga, Innova Crysta, and SUV cabs based on your comfort and passenger requirements. Enjoy doorstep pickup, professional drivers, and a smooth journey with reliable cab booking services."
  },
  {
    "name": "Belgaum to Pandharpur Taxi Booking",
    "description": "Book Belgaum to Pandharpur Taxi Booking services for comfortable and reliable transportation. Get chauffeur-driven taxis with affordable fares, clean interiors, AC facilities, and flexible travel options. Our taxi booking service is suitable for pilgrimage travel, family trips, corporate journeys, and outstation transportation."
  },
  {
    "name": "Belgaum to Pandharpur Car Rental",
    "description": "Choose Belgaum to Pandharpur Car Rental for comfortable chauffeur-driven vehicles with flexible rental options. Hire a car for temple visits, family tours, business trips, and sightseeing requirements. Our rental services include well-maintained cars, experienced drivers, and convenient pickup facilities."
  },
  {
    "name": "Belgaum to Pandharpur Outstation Cab",
    "description": "Book Belgaum to Pandharpur Outstation Cab for safe and comfortable long-distance travel. Enjoy reliable transportation with professional chauffeurs, spacious AC vehicles, and flexible trip plans. Our outstation cabs are perfect for pilgrims, families, tourists, corporate passengers, and individual travelers."
  },
  {
    "name": "Belgaum to Pandharpur Innova Crysta Cab",
    "description": "Travel with Belgaum to Pandharpur Innova Crysta Cab for premium comfort and spacious interiors. Innova Crysta is ideal for family groups, pilgrimage tours, corporate travel, and passengers carrying extra luggage. Enjoy luxury seating, smooth performance, and professional chauffeur service."
  },
  {
    "name": "Belgaum to Pandharpur Ertiga Cab",
    "description": "Book Belgaum to Pandharpur Ertiga Cab for affordable and spacious travel. Ertiga offers comfortable seating, AC facilities, and sufficient luggage space for small groups and families. Perfect for temple visits, weekend trips, airport transfers, and outstation travel."
  },
  {
    "name": "Belgaum to Pandharpur Sedan Cab",
    "description": "Choose Belgaum to Pandharpur Sedan Cab for economical and comfortable transportation. Sedan cars are suitable for couples, small families, and business travelers who need a smooth AC ride with professional drivers. Enjoy clean vehicles, affordable rates, and reliable service."
  },
  {
    "name": "Belgaum to Pandharpur Round Trip Cab",
    "description": "Hire Belgaum to Pandharpur Round Trip Cab for flexible return travel packages. Ideal for Pandharpur pilgrimage, family tours, sightseeing, and weekend trips. Enjoy a dedicated vehicle, experienced chauffeur, comfortable seating, and convenient travel schedules."
  },
  {
    "name": "Belgaum to Pandharpur Private Taxi",
    "description": "Book Belgaum to Pandharpur Private Taxi for a personalized and comfortable travel experience. Get complete privacy with a dedicated vehicle, professional driver, AC comfort, and flexible pickup options. Suitable for families, couples, devotees, and corporate passengers."
  },
  {
    "name": "Cheap Belgaum to Pandharpur Cab",
    "description": "Find Cheap Belgaum to Pandharpur Cab services offering affordable fares with quality travel facilities. Choose budget-friendly Sedan, Ertiga, and other vehicle options without compromising safety and comfort. Enjoy reliable transportation with experienced chauffeurs and easy booking options."
  },
  {
    "name": "Best Belgaum to Pandharpur Taxi Service",
    "description": "Choose Best Belgaum to Pandharpur Taxi Service for dependable travel with premium vehicles and skilled chauffeurs. Experience safe journeys, timely pickup, comfortable rides, and customized travel solutions for pilgrimage, family, business, and personal trips."
  },
  {
    "name": "Online Belgaum to Pandharpur Cab Booking",
    "description": "Book Online Belgaum to Pandharpur Cab Booking with simple reservations and quick vehicle selection. Choose your preferred cab type and travel schedule easily. Enjoy online booking convenience, professional drivers, and comfortable outstation travel solutions."
  },
  {
    "name": "Belgaum to Pandharpur Taxi Fare",
    "description": "Check Belgaum to Pandharpur Taxi Fare based on vehicle type, trip duration, and travel requirements. Select from Sedan, Ertiga, Innova Crysta, and SUV options with transparent pricing. Get comfortable rides with professional chauffeur services at competitive rates."
  },
  {
    "name": "Belgaum to Pandharpur Car Hire",
    "description": "Hire Belgaum to Pandharpur Car Hire services for reliable chauffeur-driven transportation. Select vehicles according to passenger count, luggage capacity, and comfort preferences. Suitable for pilgrimage tours, family travel, corporate trips, and personal journeys."
  },
  {
    "name": "Belgaum to Pandharpur Cab Price",
    "description": "Get affordable Belgaum to Pandharpur Cab Price options with different vehicle categories and flexible travel plans. Choose economical cabs or premium vehicles according to your requirements. Enjoy transparent pricing, comfortable travel, and reliable driver assistance."
  },
  {
    "name": "Belgaum to Pandharpur Family Cab",
    "description": "Book Belgaum to Pandharpur Family Cab for safe and comfortable travel with your loved ones. Spacious vehicles, experienced chauffeurs, AC comfort, and luggage-friendly interiors make your family journey convenient and relaxing."
  },
  {
    "name": "Belgaum to Pandharpur Corporate Taxi",
    "description": "Choose Belgaum to Pandharpur Corporate Taxi for professional business transportation solutions. Get punctual service, executive vehicles, experienced drivers, and customized travel options for meetings, employee travel, and corporate requirements."
  },
  {
    "name": "Belgaum to Pandharpur Airport Transfer",
    "description": "Book Belgaum to Pandharpur Airport Transfer service for smooth airport pickup and drop transportation. Enjoy timely service, comfortable AC vehicles, professional chauffeurs, and convenient travel arrangements for business travelers and families."
  },
  {
    "name": "Belgaum to Pandharpur Cab Fare",
    "description": "Plan your journey with Belgaum to Pandharpur Cab Fare options designed for different travel needs. Enjoy flexible pricing, comfortable vehicles, experienced drivers, and reliable transportation services for your outstation journey."
  },
  {
    "name": "Belgaum to Pandharpur Taxi Near Me",
    "description": "Find Belgaum to Pandharpur Taxi Near Me services for quick and convenient travel arrangements. Get reliable private taxis with professional drivers, comfortable vehicles, and flexible pickup locations for a hassle-free journey."
  },
  {
    "name": "Belgaum to Pandharpur Outstation Taxi",
    "description": "Book Belgaum to Pandharpur Outstation Taxi for safe and reliable long-distance transportation. Enjoy spacious seating, AC comfort, experienced chauffeurs, and flexible travel options for pilgrims, families, tourists, and corporate passengers."
  },
  {
    "name": "Belgaum to Pandharpur Travel by Cab",
    "description": "Enjoy Belgaum to Pandharpur Travel by Cab with comfortable private transportation and professional driver assistance. Plan your pilgrimage or personal trip with one way and round trip options for a safe, convenient, and relaxing journey."
  }
],
"tableData": [
  ["Belgaum to Pandharpur Cab", "Belgaum to Pandharpur Taxi"],
  ["Belgaum to Pandharpur Cab Service", "Belgaum to Pandharpur Taxi Service"],
  ["Belgaum to Pandharpur One Way Cab", "Belgaum to Pandharpur One Way Taxi"],
  ["Belgaum to Pandharpur Cab Booking", "Belgaum to Pandharpur Taxi Booking"],
  ["Belgaum to Pandharpur Car Rental", "Belgaum to Pandharpur Outstation Cab"],
  ["Belgaum to Pandharpur Innova Crysta Cab", "Belgaum to Pandharpur Ertiga Cab"],
  ["Belgaum to Pandharpur Sedan Cab", "Belgaum to Pandharpur Round Trip Cab"],
  ["Belgaum to Pandharpur Private Taxi", "Cheap Belgaum to Pandharpur Cab"],
  ["Best Belgaum to Pandharpur Taxi Service", "Online Belgaum to Pandharpur Cab Booking"],
  ["Belgaum to Pandharpur Taxi Fare", "Belgaum to Pandharpur Car Hire"],
  ["Belgaum to Pandharpur Cab Price", "Belgaum to Pandharpur Family Cab"],
  ["Belgaum to Pandharpur Corporate Taxi", "Belgaum to Pandharpur Airport Transfer"],
  ["Belgaum to Pandharpur Cab Fare", "Belgaum to Pandharpur Taxi Near Me"],
  ["Belgaum to Pandharpur Outstation Taxi", "Belgaum to Pandharpur Travel by Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Comfortable Belgaum to Pandharpur Cab Service",
    WhyChoosedescription: "Travel from Belgaum to Pandharpur with a reliable taxi service offering comfortable vehicles, experienced drivers, and convenient travel options for a peaceful journey."
  },
  {
    WhyChooseheading: "Ideal Taxi for Pilgrimage Travel",
    WhyChoosedescription: "Our Belgaum to Pandharpur cabs are suitable for devotees, families, and groups visiting the famous pilgrimage destination with flexible travel arrangements."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options Available",
    WhyChoosedescription: "Choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, and SUV cabs according to your passenger count and comfort requirements."
  },
  {
    WhyChooseheading: "Doorstep Pickup Facility",
    WhyChoosedescription: "Get convenient pickup from your home, hotel, office, railway station, airport area, or any preferred location in Belgaum."
  },
  {
    WhyChooseheading: "Experienced Drivers for Long Routes",
    WhyChoosedescription: "Professional chauffeurs provide safe driving, proper route knowledge, and a comfortable travel experience throughout the Belgaum to Pandharpur journey."
  },
  {
    WhyChooseheading: "One Way & Round Trip Flexibility",
    WhyChoosedescription: "Select a one-way cab for direct travel or choose a return taxi package according to your pilgrimage schedule and requirements."
  },
  {
    WhyChooseheading: "Spacious & Well-Maintained Cars",
    WhyChoosedescription: "Enjoy a relaxed journey with clean interiors, comfortable seating, and regularly serviced vehicles suitable for long-distance travel."
  },
  {
    WhyChooseheading: "Simple Booking Process",
    WhyChoosedescription: "Get quick assistance for vehicle selection, fare details, and trip planning to arrange your Belgaum to Pandharpur cab easily."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Pandharpur Cab Service?",
    answer: "Yes, we provide Belgaum to Pandharpur taxi services with comfortable cars and professional drivers for pilgrimage and personal travel."
  },
  {
    question: "Can I book a one-way taxi from Belgaum to Pandharpur?",
    answer: "Yes, one-way cab service is available for passengers who need direct travel without a return journey."
  },
  {
    question: "Which vehicles are available for Belgaum to Pandharpur travel?",
    answer: "You can choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, and SUV cabs based on your requirements."
  },
  {
    question: "Is this cab service suitable for family pilgrimage trips?",
    answer: "Yes, spacious and comfortable vehicles are available for families, senior citizens, and groups travelling to Pandharpur."
  },
  {
    question: "Can I book a return cab from Pandharpur to Belgaum?",
    answer: "Yes, return journey taxi options are available with flexible timings according to your travel plan."
  },
  {
    question: "Do you provide pickup from Belgaum Airport and Railway Station?",
    answer: "Yes, pickup and drop services are available from Belgaum Airport, Railway Station, hotels, and other preferred locations."
  },
  {
    question: "Can I hire a private taxi for Belgaum to Pandharpur?",
    answer: "Yes, private cab services are available with dedicated vehicles and drivers for a comfortable journey."
  },
  {
    question: "Are toll and parking charges included in the taxi fare?",
    answer: "Applicable toll, parking, and additional travel charges depend on the selected package and are explained during booking."
  },
  {
    question: "Is Belgaum to Pandharpur taxi available 24/7?",
    answer: "Yes, taxi booking assistance is available for planned trips and urgent travel requirements."
  },
  {
    question: "How can I book a Belgaum to Pandharpur Cab?",
    answer: "Share your pickup location, travel date, passenger details, and preferred vehicle type to receive fare details and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Vijay Kulkarni",
    feedback: "The Belgaum to Pandharpur cab service was very comfortable. The driver was polite, the vehicle was clean, and the journey was managed smoothly.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sunita Patil",
    feedback: "We travelled with family for a pilgrimage visit and had a great experience. The cab was spacious and the overall service was excellent.",
    rating: 5
  }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Pandharpur Cab",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-pandharpur-cab.webp",
  "description":
    "Book Belgaum to Pandharpur Cab with Belgaum Taxi Service for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Belgaum to Pandharpur with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for pilgrimage tours, family trips, business travel, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-pandharpur-cab"
  }
};

    return (
        <div>





<Helmet>
  <title>Belgaum to Pandharpur Cab | One Way Taxi Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Pandharpur Cab with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Get affordable cabs from Belgaum to Pandharpur with Sedan, Ertiga, SUV, Innova, and Innova Crysta for comfortable outstation travel and pilgrimage tours available 24x7."
  />

  <meta
    name="keywords"
    content="Belgaum to Pandharpur Cab, Belgaum to Pandharpur Taxi, Belgaum to Pandharpur Cab Service, Belgaum to Pandharpur Taxi Service, Belgaum to Pandharpur One Way Cab, Belgaum to Pandharpur One Way Taxi, Belgaum to Pandharpur Cab Booking, Belgaum to Pandharpur Taxi Booking, Belgaum to Pandharpur Car Rental, Belgaum to Pandharpur Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/49.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtopandharpurcab ;